module.exports = __webpack_public_path__ + "static/media/seguros-mundial-off-app-provider-icon.f3c18232.svg";